<template>
  <v-row>

    <v-col cols="12" class="mt-4">
      <v-sheet
        outlined 
        class="pb-8">

        <v-row>
          <v-col cols="12" class="pt-8 pl-8 pr-8">
            <h4>Asistentes totales:</h4>
          </v-col>

          <v-col cols="12" class="d-flex align-center justify-center">
            <v-sheet
              outlined
              height="160px"
              max-width="280px">
              <v-row class="pa-2">
                <v-col cols="6">
                  <v-img 
                    alt="UNL" 
                    contain
                    height="80px"
                    :src="require('@/assets/img/users.png')">
                  </v-img>
                </v-col>
                
                <v-col cols="6" class="d-flex align-center justify-center">
                  <h1 class="text-left">{{ participants_count }}</h1>
                </v-col>

                <v-col cols="12">
                  <h4 class="text-center">Asistentes Totales</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        class="pb-8"
        min-height="400"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between pa-8">
            <h4>Asistentes por país:</h4>

            <div>
              <v-btn-toggle
                v-model="participant_country_view"
                rounded
                mandatory
              >
                <v-btn small>
                  <v-icon small>mdi-border-all</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-chart-bar</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-chart-pie</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>

          </v-col>

          <template v-if="participant_country_view==0">
            <v-col 
              cols="12" 
              xl="3" 
              md="3" 
              sm="12" 
              class="pl-8 pr-8"
              v-for="item in participants_country_count" v-bind:key="item.country_id">
              <v-sheet
                outlined
                height="120px">
                <v-row class="pa-1">
  
                  
                  <v-col cols="12" class="d-flex align-center justify-center">
                    <h1 class="text-center">{{ item.count }}</h1>
                  </v-col>
  
                  <v-col cols="12">
                    <h5 class="text-center">{{ item.name }}</h5>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </template>

          <template v-if="participant_country_view==1">
            <v-col cols="12">
              <apexchart 
                type="bar" 
                height="400" 
                :options="participants_country_chart_options" 
                :series="participants_country_series">
              </apexchart>
            </v-col>   
          </template>

          <template v-if="participant_country_view==2">
            <v-col cols="12">
              <apexchart
                class="pb-8"
                type="pie" 
                height="400"
                :options="participants_country_chart_options" 
                :series="participants_country_series[0].data">>
              </apexchart>
            </v-col>   
          </template>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        min-height="400"
        class="pb-8"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between pa-8">
            <h4>Asistentes por provicias argentinas:</h4>

            <div>
              <v-btn-toggle
                v-model="participants_provicias_view"
                rounded
                mandatory
              >
                <v-btn small>
                  <v-icon small>mdi-border-all</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-chart-bar</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-chart-pie</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>

          </v-col>

          <template v-if="participants_provicias_view==0">
            <v-col 
              cols="12" 
              xl="3" 
              md="3" 
              sm="12" 
              class="pl-8 pr-8"
              v-for="item in participants_provincias_count" :key="item.provincia_id">
              <v-sheet
                outlined
                height="130px">
                <v-row class="pa-2">
  
                  
                  <v-col cols="12" class="d-flex align-center justify-center">
                    <h1 class="text-center">{{ item.count }}</h1>
                  </v-col>
  
                  <v-col cols="12">
                    <h5 class="text-center">{{ item.name }}</h5>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </template>

          <template v-if="participants_provicias_view==1">
            <v-col cols="12">
              <apexchart 
                type="bar" 
                height="400" 
                :options="participants_provincias_chart_options" 
                :series="participants_provincias_series">
              </apexchart>
            </v-col>   
          </template>

          <template v-if="participants_provicias_view==2">
            <v-col cols="12">
              <apexchart
                class="pb-8"
                type="pie" 
                height="400"
                :options="participants_provincias_chart_options" 
                :series="participants_provincias_series[0].data">>
              </apexchart>
            </v-col>   
          </template>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">
      <v-sheet
        outlined
        height="550"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between pa-8">
            <h4>Asistentes por institución:</h4>

            <div>
              <v-btn-toggle
                v-model="participant_institution_view"
                rounded
                mandatory
              >
                <v-btn small>
                  <v-icon small>mdi-chart-pie</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-menu</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>

          <template v-if="participant_institution_view==0">
            <v-col cols="12">
              <apexchart
                class="pb-8"
                type="pie" 
                height="450"
                :options="participants_institution_belongs_series_pie_options" 
                :series="participants_institution_belongs_series[0].data">>
              </apexchart>
            </v-col>
          </template>

          <template v-if="participant_institution_view==1">
            <v-col cols="12" class="pa-8">
              <v-row v-for="participant in participants_institution_belongs_count" :key="participant.count">
                <v-col cols="8">
                  <h4 class="text-right">{{ participant.institution_you_are_part }}:</h4>
                </v-col>
                <v-col cols="4">
                  {{ participant.count }}
                </v-col>
              </v-row>
            </v-col>
          </template>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">
      <v-sheet
        outlined
        height="550"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pt-8 pl-8 pr-8">
            <h4>Asistentes de otras instituciones:</h4>
          </v-col>
  
          <v-col cols="12" class="pt-8">

            <v-row>
              <v-col cols="12">
                <v-simple-table height="460">
                  <thead>
                    <tr>
                      <th class="text-left">
                        Institución
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in participants_other_institutions"
                      :key="item.id"
                    >
                      <td class="pr-8">{{ item.institution }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">
      <v-sheet
        outlined
        height="550"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between pa-8">
            <h4>Asistentes por género:</h4>

            <div>
              <v-btn-toggle
                v-model="participant_gender_view"
                rounded
                mandatory
              >
                <v-btn small>
                  <v-icon small>mdi-chart-pie</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-menu</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
          
          <template v-if="participant_gender_view==0">
            <v-col cols="12">
              <apexchart
                class="pb-8"
                type="pie" 
                height="450"
                :options="participants_per_gender_series_pie_options" 
                :series="participants_per_gender_series[0].data">>
              </apexchart>
            </v-col>
          </template>

          <template v-if="participant_gender_view==1">
            <v-col cols="12" class="pt-8 pb-8 pl-2 pr-2">

              <v-row v-for="participant in participants_per_gender_count" :key="participant.name">
                <v-col cols="6">
                  <h4 class="text-right">{{ participant.name }}:</h4>
                </v-col>
                <v-col cols="6">
                  {{ participant.count }}
                </v-col>
              </v-row>
            </v-col>
          </template>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">
      <v-sheet
        outlined
        height="550"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between pa-8">
            <h4>Asistentes que quieren recibir información:</h4>
          </v-col>
          
          <v-col cols="12">
            <apexchart
              class="pb-8"
              type="pie" 
              height="450"
              :options="participants_receive_information_series_pie_options" 
              :series="participants_receive_information_series[0].data">>
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        class="pb-8"
        min-height="500"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between pa-8">
            <h4>Nivel de estudios de los asistentes:</h4>

            <div>
              <v-btn-toggle
                v-model="participants_completed_studies_view"
                rounded
                mandatory
              >
                <v-btn small>
                  <v-icon small>mdi-border-all</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-chart-bar</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-chart-pie</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>

          </v-col>

          <template v-if="participants_completed_studies_view==0">
            <v-col 
              cols="12" 
              xl="3" 
              md="3" 
              sm="12" 
              class="pl-8 pr-8"
              v-for="participant in participants_completed_studies" :key="participant.name">
              <v-sheet
                outlined
                height="120px">
                <v-row class="pa-1">
  
                  
                  <v-col cols="12" class="d-flex align-center justify-center">
                    <h1 class="text-center">{{ participant.count }}</h1>
                  </v-col>
  
                  <v-col cols="12">
                    <h5 class="text-center">{{ participant.name }}</h5>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </template>

          <template v-if="participants_completed_studies_view==1">
            <v-col cols="12">
              <apexchart 
                type="bar" 
                height="400" 
                :options="participants_completed_studies_chart_options" 
                :series="participants_completed_studies_series">
              </apexchart>
            </v-col>   
          </template>

          <template v-if="participants_completed_studies_view==2">
            <v-col cols="12">
              <apexchart
                class="pb-8"
                type="pie" 
                height="400"
                :options="participants_completed_studies_chart_options" 
                :series="participants_completed_studies_series[0].data">>
              </apexchart>
            </v-col>   
          </template>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        height="480"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pt-8 pl-8 pr-8">
            <h4>Recorrido por asistente:</h4>
          </v-col>
  
          <v-col cols="12" class="pt-8">

            <v-row>
              <v-col cols="4">
                <v-simple-table height="390">
                  <tbody>
                    <tr
                      style="cursor:pointer"
                      v-for="item in participants"
                      :key="item.user_id"
                      @click="getParticipantRoad(item)"
                    >
                      <td 
                        class="pr-8"
                        >{{ item.lastname +', '+ item.name }}
                      </td>

                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="8" v-if="current_participant!=null">
                <v-container style="height: 390px; overflow-y: auto;">
                  <v-timeline
                    dense
                    clipped
                  >
                    <v-timeline-item
                      fill-dot
                      class="white--text d-flex align-center"
                      color="orange"
                      large
                    >
                      <template v-slot:icon>
                        <span>{{ current_participant.name[0]+current_participant.lastname[0] }}</span>
                      </template>
                      <h4 class="black--text">
                        {{ current_participant.name + ' ' + current_participant.lastname  }}
                      </h4>
                    </v-timeline-item>

                    <v-timeline-item
                      class="mb-4"
                      small
                      v-for="road in road_participant"
                      v-bind:key="road.id"
                    >
                      <v-row justify="space-between">
                        <v-col cols="7">
                          <v-chip
                            class="white--text ml-0"
                            :color="formattedColorURL(road.url)"
                            label
                            small
                          >
                            {{ formattedURL(road.url) }}
                          </v-chip>
                        </v-col>
                        <v-col
                          class="text-right"
                          cols="5"
                        >
                          {{ formattedDate(road.created_at) }}
                        </v-col>
                      </v-row>
                    </v-timeline-item>

                  </v-timeline>
                </v-container>
              </v-col>

            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">
      <v-sheet
        outlined
        height="550"
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between pa-8">
            <h4>Como conocieron la Jornada:</h4>

            <div>
              <v-btn-toggle
                v-model="participants_communication_channel_view"
                rounded
                mandatory
              >
                <v-btn small>
                  <v-icon small>mdi-chart-pie</v-icon>
                </v-btn>
                <v-btn small>
                  <v-icon small>mdi-menu</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>

          </v-col>

          <template v-if="participants_communication_channel_view==0">
            <v-col cols="12">
              <apexchart
                class="pb-8"
                type="pie" 
                height="450"
                :options="participants_communication_channel_chart_options" 
                :series="participants_communication_channel_series[0].data">>
              </apexchart>
            </v-col>
          </template>

          <template v-if="participants_communication_channel_view==1">
            <v-col cols="12" class="pt-8 pb-8 pl-2 pr-2">

              <v-row v-for="participant in participants_communication_channel" :key="participant.name">
                <v-col cols="6">
                  <h4 class="text-right">{{ participant.name }}:</h4>
                </v-col>
                <v-col cols="6">
                  {{ participant.count }}
                </v-col>
              </v-row>

            </v-col>
          </template>

        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'participantsIndicator',

    props:['edition_id'],
    data: () => ({
      loading:true,

      toggle_exclusive: 0,

      participants_count:0,
      
      participant_country_view: false,
      participants_country_count:[],
      participants_country_chart_options: {
        name: 'Asistentes',
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
          }
        },
        labels: [],
        xaxis: {
          categories: []
        }
      },
      participants_country_series: [
        {
          name: 'Asistentes',
          data: []
        }
      ],

      participants_provicias_view: 0,
      participants_provincias_count:[],
      participants_provincias_chart_options: {
        name: 'Asistentes',
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
          }
        },
        labels: [],
        xaxis: {
          categories: []
        }
      },
      participants_provincias_series: [
        {
          name: 'Asistentes',
          data: []
        }
      ],

      interaction_views_chart_options: [],
      interaction_views_series: [],
      
      participant_gender_view:0,
      participants_per_gender_count:[],
      participants_per_gender_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],
      participants_per_gender_series_pie_options: {
        chart: {
          type: "pie",
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
      },

      participant_institution_view: 0,
      participants_institution_belongs_count:[],
      participants_institution_belongs_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],
      participants_institution_belongs_series_pie_options: {
        chart: {
          type: "pie",
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
      },

      participants_other_institutions: [],

      participants_receive_information:[],
      participants_receive_information_series: [
        {
          name: 'Asistente',
          data: []
        }
      ],
      participants_receive_information_series_pie_options: {
        chart: {
          type: "pie",
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
      },

      participants_completed_studies_view: 0,
      participants_completed_studies:[],
      participants_completed_studies_chart_options: {
        name: 'Asistentes',
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
          }
        },
        labels: [],
        xaxis: {
          categories: []
        }
      },
      participants_completed_studies_series: [
        {
          name: 'Asistentes',
          data: []
        }
      ],

      participants_communication_channel_view: 0,
      participants_communication_channel:[],
      participants_communication_channel_chart_options: {
        name: 'Asistentes',
        plotOptions: {
          bar: {
            borderRadius: 6,
            horizontal: false,
          }
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
        labels: [],
        xaxis: {
          categories: []
        }
      },
      participants_communication_channel_series: [
        {
          name: 'Asistentes',
          data: []
        }
      ],
      
      current_participant: null,
      participants: [],
      road_participant: []

    }),
    computed: {
      formattedName(item) {
        return `${item.lastname}, ${item.name}`;
      }
    },
    methods:{
      formattedDate(created_at) 
      {
        const date = new Date(created_at);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        // Agregar ceros a la izquierda si es necesario
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedMonth = month < 10 ? '0' + month : month;
        const formattedYear = year;
        const formattedHours = hours < 10 ? '0' + hours : hours;
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        return `${formattedDay}/${formattedMonth}/${formattedYear} ${formattedHours}:${formattedMinutes}`;
      },

      formattedURL(url)
      {
        switch (url) {
          case 'home':
            url = 'Home';
            break;

          case 'auditorium':
            url = 'Auditorio';
            break;

          case 'project-gallery':
            url = 'Galeria de Proyectos';
            break;
          
          case 'like':
            url = 'Dio Like a un proyecto';
            break;

          case 'view':
            url = 'Vio un proyecto';
            break;

          case 'entrepreneurs':
            url = 'Emprendedores';
            break;

          case 'sponsors':
            url = 'Sponsors';
            break;

          case 'program':
            url = 'Programa';
            break;
          
          case 'speakers':
            url = 'Speakers';
            break;

          case 'juries-evaluators':
            url = 'Jurado y Evaluadores';
            break;

          case 'about':
            url = 'Acerca de JIJE';
            break;

          default:
            break;
        }

        return url
      },

      formattedColorURL(url)
      {
        switch (url) {
          case 'home':
            url = 'black';
            break;

          case 'auditorium':
            url = 'purple';
            break;

          case 'project-gallery':
            url = 'grey';
            break;
          
          case 'like':
            url = 'red';
            break;

          case 'view':
            url = 'blue';
            break;

          case 'entrepreneurs':
            url = 'lime';
            break;

          case 'sponsors':
            url = 'green';
            break;

          case 'program':
            url = 'brown';
            break;
          
          case 'speakers':
            url = 'pink';
            break;

          case 'juries-evaluators':
            url = 'deep-purple';
            break;

          case 'about':
            url = 'cyan';
            break;

          default:
            break;
        }

        return url
      },

      async getParticipants()
      {
        await axios.get('admin/indicators/participants/'+this.edition_id).then(response =>{
          this.participants_count = response.data.data.participants_count
          this.participants = response.data.data.participants
        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantRoad(item){
        this.current_participant = item
        this.road_participant = []
        this.road_participant_2 = []
        await axios.get('admin/indicators/participants/'+this.edition_id+'/road/'+this.current_participant.user_id).then(response =>{
          this.road_participant = response.data.data.road_participant
        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsCountries()
      {
        await axios.get('admin/indicators/participants/'+this.edition_id+'/countries').then(response =>{
          this.participants_country_count = response.data.data.participants_country_count

          this.participants_country_count.forEach( element => {
            this.participants_country_chart_options.xaxis.categories.push(element.name)
            this.participants_country_chart_options.labels.push( element.name )
            this.participants_country_series[0].data.push(element.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsProvincias()
      {
        await axios.get('admin/indicators/participants/'+this.edition_id+'/provincias').then(response =>{
          this.participants_provincias_count = response.data.data.participants_provincias_count

          this.participants_provincias_count.forEach( element => {
            this.participants_provincias_chart_options.xaxis.categories.push(element.name)
            this.participants_provincias_chart_options.labels.push( element.name )
            this.participants_provincias_series[0].data.push(element.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsGenders()
      {
        this.participants_per_gender_series_pie_options.labels = []
        this.participants_per_gender_series[0].data = []

        await axios.get('admin/indicators/participants/'+this.edition_id+'/genders').then(response =>{
          this.participants_per_gender_count = response.data.data.participants_per_gender_count

          this.participants_per_gender_count.forEach(element => {
            this.participants_per_gender_series_pie_options.labels.push( element.name )
            this.participants_per_gender_series[0].data.push( element.count )
          });

        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsInstitutionBelongs()
      {
        this.participants_institution_belongs_series_pie_options.labels = []
        this.participants_institution_belongs_series[0].data = []

        await axios.get('admin/indicators/participants/'+this.edition_id+'/institution-belongs').then(response =>{
          this.participants_institution_belongs_count = response.data.data.participants_institution_belongs_count

          this.participants_institution_belongs_count.forEach(element => {
            this.participants_institution_belongs_series_pie_options.labels.push( element.institution_you_are_part )
            this.participants_institution_belongs_series[0].data.push( element.count )
          });

        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsOtherInstitutions()
      {
        await axios.get('admin/indicators/participants/'+this.edition_id+'/other-institutions').then(response =>{
          this.participants_other_institutions = response.data.data.participants_other_institutions
        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsReceiveInformation()
      {
        this.participants_receive_information_series_pie_options.labels = []
        this.participants_receive_information_series[0].data = []

        await axios.get('admin/indicators/participants/'+this.edition_id+'/receive-information').then(response =>{
          this.participants_receive_information = response.data.data.participants_receive_information

          this.participants_receive_information.forEach(element => {
            this.participants_receive_information_series_pie_options.labels.push( element.receive_information )
            this.participants_receive_information_series[0].data.push( element.count )
          });

        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsCompletedStudies()
      {
        await axios.get('admin/indicators/participants/'+this.edition_id+'/educational-level').then(response =>{
          this.participants_completed_studies = response.data.data.participants_completed_studies

          this.participants_completed_studies.forEach( element => {
            this.participants_completed_studies_chart_options.xaxis.categories.push(element.name)
            this.participants_completed_studies_chart_options.labels.push( element.name )
            this.participants_completed_studies_series[0].data.push(element.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },

      async getParticipantsCommunicationChannels()
      {
        await axios.get('admin/indicators/participants/'+this.edition_id+'/communication-channels').then(response =>{
          this.participants_communication_channel = response.data.data.participants_communication_channel

          this.participants_communication_channel.forEach( element => {
            this.participants_communication_channel_chart_options.xaxis.categories.push(element.name)
            this.participants_communication_channel_chart_options.labels.push( element.name )
            this.participants_communication_channel_series[0].data.push(element.count)
          })
        }).catch(error => {
          console.log(error);
        })
      },
      
    },
    created(){
      Promise.all([
        this.getParticipants(),
        this.getParticipantsCountries(),
        this.getParticipantsGenders(),
        this.getParticipantsProvincias(),
        this.getParticipantsInstitutionBelongs(),
        this.getParticipantsOtherInstitutions(),
        this.getParticipantsReceiveInformation(),
        this.getParticipantsCompletedStudies(),
        this.getParticipantsCommunicationChannels()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>